import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SUPPLIERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('SUPPLIERS');
export const SUPPLIERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SUPPLIERS_CRUD_ACTION_CONSTANTS
);
